var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVsBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 447,
    viewBox: "0 0 335 447",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1009_11802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.333 29.8H44.6667V44.7H290.333V29.8Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6667 44.7H29.7778V402.3H44.6667V44.7Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.222 44.7H290.333V402.3H305.222V44.7Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.333 402.3H44.6667V417.2H290.333V402.3Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.333 44.7H44.6666V402.3H290.333V44.7Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.556 74.5H74.4445V193.7H260.556V74.5Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.556 74.5H74.4445V89.4H260.556V74.5Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.556 178.8H74.4445V193.7H260.556V178.8Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.667 104.3H89.3334V119.2H245.667V104.3Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.444 134.1H89.3334V145.275H208.444V134.1Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.333 156.45H89.3334V167.625H223.333V156.45Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.556 223.5H74.4445V342.7H260.556V223.5Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.556 223.5H74.4445V238.4H260.556V223.5Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.556 327.8H74.4445V342.7H260.556V327.8Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.556 238.4H74.4445V245.85H260.556V238.4Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.556 253.3H74.4445V260.75H260.556V253.3Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.556 268.2H74.4445V275.65H260.556V268.2Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.556 283.1H74.4445V290.55H260.556V283.1Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.556 298H74.4445V305.45H260.556V298Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.556 312.9H74.4445V320.35H260.556V312.9Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.222 44.7H44.6666V104.3H104.222V44.7Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.222 89.3999H59.5555V134.1H104.222V89.3999Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.889 74.5H74.4445V104.3H148.889V74.5Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.889 104.3H89.3333V119.2H148.889V104.3Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.222 223.5H74.4445V312.9H104.222V223.5Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.333 44.7H230.778V402.3H290.333V44.7Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.333 342.7H186.111V402.3H290.333V342.7Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.556 74.5H223.333V193.7H260.556V74.5Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.555 223.5H230.778V342.7H260.555V223.5Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268 89.3999H238.222V119.2H268V89.3999Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.111 89.3999H238.222V104.3H253.111V89.3999Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.778 357.6H104.222V387.4H230.778V357.6Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.667 372.5H89.3334V402.3H245.667V372.5Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.778 387.4H104.222V402.3H230.778V387.4Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 372.5H119.111V387.4H134V372.5Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.889 372.5H201V387.4H215.889V372.5Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.111 89.3999H104.222V104.3H119.111V89.3999Z",
    fill: "#3498DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 74.5H119.111V104.3H134V74.5Z",
    fill: "#3498DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.889 89.3999H134V104.3H148.889V89.3999Z",
    fill: "#3498DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.222 119.2H208.444V134.1H238.222V119.2Z",
    fill: "#27AE60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.667 134.1H201V149H245.667V134.1Z",
    fill: "#27AE60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.111 149H193.556V163.9H253.111V149Z",
    fill: "#27AE60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.667 163.9H201V178.8H245.667V163.9Z",
    fill: "#27AE60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.222 178.8H208.444V193.7H238.222V178.8Z",
    fill: "#27AE60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.222 208.6H89.3334V216.05H104.222V208.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.111 208.6H111.667V216.05H119.111V208.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.445 208.6H126.556V216.05H141.445V208.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.778 208.6H148.889V216.05H163.778V208.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 410.925L66.496 433.313L68.0761 431.655L44.5801 409.267L43 410.925Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5802 409.267L68.0762 431.655L71.2364 428.338L47.7404 405.95L44.5802 409.267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7404 405.95L71.2365 428.338L72.8166 426.68L49.3206 404.292L47.7404 405.95Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9987 405.891L71.1382 425.081L72.7183 423.422L52.5789 404.233L50.9987 405.891Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2572 405.832L71.04 421.823L72.6202 420.165L55.8373 404.173L54.2572 405.832Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5156 405.773L70.9419 418.566L72.522 416.907L59.0957 404.114L57.5156 405.773Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7739 405.713L70.8436 415.308L72.4238 413.65L62.354 404.055L60.7739 405.713Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0323 405.654L70.7455 412.051L72.3256 410.392L65.6125 403.996L64.0323 405.654Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3281 420.461L64.7195 428.456L66.2996 426.798L57.9082 418.802L56.3281 420.461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2298 417.203L66.2996 426.798L67.8797 425.14L57.81 415.545L56.2298 417.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.81 415.545L66.2014 423.541L67.7815 421.882L59.3901 413.887L57.81 415.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5801 409.267L49.615 414.064L52.7752 410.748L47.7404 405.95L44.5801 409.267Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7404 405.95L51.0969 409.148L52.677 407.49L49.3205 404.292L47.7404 405.95Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9988 405.891L56.0337 410.688L57.6138 409.03L52.579 404.232L50.9988 405.891Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2571 405.832L59.292 410.629L60.8721 408.971L55.8373 404.173L54.2571 405.832Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.69 417L122 435.463L123.303 437.347L149.994 418.884L148.69 417Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.994 418.884L123.303 437.347L125.909 441.115L152.6 422.651L149.994 418.884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.6 422.651L125.909 441.115L127.213 442.999L153.903 424.535L152.6 422.651Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.997 425.854L129.119 441.68L130.422 443.563L153.3 427.738L151.997 425.854Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.393 429.056L132.329 442.245L133.632 444.128L152.696 430.94L151.393 429.056Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.79 432.259L135.538 442.81L136.841 444.693L152.093 434.143L150.79 432.259Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.187 435.462L138.748 443.375L140.051 445.258L151.49 437.345L150.187 435.462Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.583 438.664L141.957 443.939L143.261 445.823L150.886 440.548L149.583 438.664Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.648 428.115L127.116 434.709L128.419 436.593L137.952 429.999L136.648 428.115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.858 428.68L128.419 436.593L129.722 438.477L141.161 430.564L139.858 428.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.161 430.564L131.629 437.158L132.932 439.042L142.464 432.448L141.161 430.564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.994 418.884L144.274 422.84L146.88 426.608L152.6 422.651L149.994 418.884Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.6 422.651L148.787 425.289L150.09 427.173L153.903 424.535L152.6 422.651Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.997 425.854L146.277 429.81L147.58 431.694L153.3 427.738L151.997 425.854Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.393 429.056L145.674 433.013L146.977 434.897L152.696 430.94L151.393 429.056Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.199 432.403L179.826 408.913L178.168 410.563L201.541 434.052L203.199 432.403Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.541 434.052L178.168 410.563L174.852 413.862L198.225 437.352L201.541 434.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.225 437.352L174.852 413.862L173.195 415.512L196.567 439.001L198.225 437.352Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.898 437.323L174.864 417.189L173.206 418.839L193.24 438.973L194.898 437.323Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.571 437.295L174.876 420.517L173.218 422.166L189.913 438.945L191.571 437.295Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.243 437.267L174.887 423.844L173.229 425.494L186.585 438.917L188.243 437.267Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.916 437.239L174.899 427.172L173.241 428.822L183.258 438.888L184.916 437.239Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.589 437.211L174.911 430.499L173.253 432.149L179.931 438.86L181.589 437.211Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.855 422.308L181.507 413.918L179.849 415.568L188.197 423.957L189.855 422.308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.866 425.635L179.849 415.568L178.191 417.218L188.208 427.285L189.866 425.635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.208 427.285L179.861 418.896L178.203 420.545L186.551 428.934L188.208 427.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.541 434.052L196.532 429.019L193.217 432.318L198.225 437.352L201.541 434.052Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.225 437.352L194.886 433.996L193.228 435.646L196.567 439.001L198.225 437.352Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.898 437.324L189.889 432.29L188.231 433.94L193.24 438.973L194.898 437.324Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.571 437.295L186.562 432.262L184.905 433.911L189.913 438.945L191.571 437.295Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.421 438.373L270.966 417L269.414 418.63L291.869 440.003L293.421 438.373Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.869 440.003L269.415 418.63L266.311 421.891L288.766 443.264L291.869 440.003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.766 443.264L266.311 421.891L264.759 423.521L287.214 444.894L288.766 443.264Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.61 443.368L266.363 425.048L264.811 426.678L284.058 444.998L285.61 443.368Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.454 443.471L266.415 428.205L264.863 429.835L280.902 445.102L282.454 443.471Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.298 443.575L266.467 431.362L264.915 432.992L277.747 445.205L279.298 443.575Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.143 443.679L266.519 434.519L264.967 436.149L274.591 445.309L276.143 443.679Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.987 443.783L266.571 437.676L265.019 439.306L271.435 445.413L272.987 443.783Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.642 429.317L272.622 421.684L271.071 423.314L279.09 430.947L280.642 429.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.694 432.474L271.071 423.314L269.519 424.944L279.142 434.104L280.694 432.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.142 434.104L271.123 426.471L269.571 428.101L277.59 435.734L279.142 434.104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.869 440.003L287.057 435.423L283.954 438.684L288.765 443.264L291.869 440.003Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.766 443.264L285.558 440.21L284.006 441.841L287.214 444.894L288.766 443.264Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.61 443.367L280.798 438.788L279.246 440.418L284.058 444.998L285.61 443.367Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.454 443.471L277.642 438.891L276.091 440.522L280.902 445.102L282.454 443.471Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.099 442.793L215.068 437.23L213.529 435.302L206.56 440.866L208.099 442.793Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.818 442.256L215.272 433.911L213.733 431.984L203.279 440.329L204.818 442.256Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.537 441.72L215.475 430.593L213.937 428.665L199.998 439.792L201.537 441.72Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.256 441.183L215.679 427.274L214.14 425.347L196.717 439.256L198.256 441.183Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.975 440.647L215.882 423.956L214.344 422.029L193.436 438.719L194.975 440.647Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.436 438.719L214.344 422.029L212.805 420.101L191.897 436.792L193.436 438.719Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.155 438.182L214.547 418.71L213.008 416.782L188.616 436.255L190.155 438.182Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.616 436.255L213.008 416.782L209.931 412.927L185.539 432.4L188.616 436.255Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.539 432.4L209.931 412.927L208.392 411L184 430.472L185.539 432.4Z",
    fill: "#FFE44D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.248 434.765L211.991 433.375L210.452 431.447L208.71 432.838L210.248 434.765Z",
    fill: "#FFED4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.71 432.838L212.194 430.056L210.655 428.129L207.171 430.91L208.71 432.838Z",
    fill: "#FFED4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.171 430.91L212.398 426.738L210.859 424.81L205.632 428.983L207.171 430.91Z",
    fill: "#FFF266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.632 428.983L212.601 423.419L211.062 421.492L204.093 427.055L205.632 428.983Z",
    fill: "#FFF68F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.351 428.446L211.062 421.492L209.524 419.564L200.812 426.519L202.351 428.446Z",
    fill: "#FFFAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.436 438.719L198.663 434.547L197.124 432.619L191.897 436.792L193.436 438.719Z",
    fill: "#DDB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.155 438.183L195.382 434.01L193.843 432.082L188.616 436.255L190.155 438.183Z",
    fill: "#DDB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.616 436.255L192.101 433.473L189.023 429.618L185.539 432.4L188.616 436.255Z",
    fill: "#CCAA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.752 424.47L116.974 425.646L117.272 427.877L126.051 426.701L125.752 424.47Z",
    fill: "#228B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.246 426.407L115.078 428.171L115.377 430.402L128.545 428.638L128.246 426.407Z",
    fill: "#228B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.739 428.344L113.182 430.697L113.481 432.927L131.038 430.575L130.739 428.344Z",
    fill: "#228B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.233 430.281L111.286 433.221L111.585 435.452L133.532 432.512L133.233 430.281Z",
    fill: "#228B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.726 432.218L109.39 435.746L109.689 437.977L136.025 434.449L135.726 432.218Z",
    fill: "#228B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.025 434.448L109.689 437.977L109.988 440.208L136.324 436.679L136.025 434.448Z",
    fill: "#32CD32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.519 436.385L107.793 440.502L108.092 442.733L138.818 438.616L138.519 436.385Z",
    fill: "#32CD32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.818 438.616L108.092 442.733L108.69 447.195L139.416 443.078L138.818 438.616Z",
    fill: "#32CD32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.416 443.078L108.69 447.195L108.989 449.425L139.715 445.309L139.416 443.078Z",
    fill: "#4DE94D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.766 429.814L117.571 430.108L117.87 432.339L120.065 432.045L119.766 429.814Z",
    fill: "#5EFF5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.065 432.045L115.676 432.633L115.974 434.864L120.364 434.276L120.065 432.045Z",
    fill: "#5EFF5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.364 434.276L113.78 435.158L114.079 437.389L120.663 436.507L120.364 434.276Z",
    fill: "#70FF70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.663 436.507L111.884 437.683L112.183 439.914L120.962 438.738L120.663 436.507Z",
    fill: "#8FFF8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.156 438.444L112.183 439.914L112.482 442.145L123.455 440.675L123.156 438.444Z",
    fill: "#AAFFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.025 434.449L129.441 435.331L129.74 437.562L136.324 436.68L136.025 434.449Z",
    fill: "#1A7A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.519 436.385L131.935 437.267L132.234 439.498L138.818 438.616L138.519 436.385Z",
    fill: "#1A7A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.818 438.616L134.428 439.204L135.026 443.666L139.416 443.078L138.818 438.616Z",
    fill: "#0F6B0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1009_11802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 447,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVsBackground);
export default __webpack_public_path__ + "static/media/VSBackground.9a91ba2c87874d6926696b71fea85a55.svg";
export { ForwardRef as ReactComponent };